import { render } from "./about-us.vue?vue&type=template&id=ab549c20&scoped=true"
import script from "./about-us.vue?vue&type=script&lang=js"
export * from "./about-us.vue?vue&type=script&lang=js"

import "./about-us.vue?vue&type=style&index=0&id=ab549c20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab549c20"]])

export default __exports__